"use client";

import { motion } from "framer-motion";

import { crossfadeVariants } from "@/lib/animations";

export function CalendarSkeleton() {
  return (
    <motion.div
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={crossfadeVariants}
      className="mx-auto flex w-full max-w-lg flex-1 flex-col px-3 pb-24"
    >
      <header className="flex items-center justify-between gap-3 pt-4 pb-2 md:justify-start md:gap-6 md:pt-8">
        <div className="h-8 w-36 animate-pulse rounded bg-muted" />
        <div className="flex items-center gap-2">
          <div className="size-9 animate-pulse rounded-md bg-muted" />
          <div className="h-9 w-16 animate-pulse rounded-md bg-muted" />
          <div className="size-9 animate-pulse rounded-md bg-muted" />
        </div>
        <div className="hidden md:ms-auto md:flex md:items-center md:gap-2">
          <div className="size-9 animate-pulse rounded-md bg-muted" />
          <div className="size-9 animate-pulse rounded-md bg-muted" />
        </div>
      </header>

      <div className="mt-2 space-y-1">
        {Array.from({ length: 7 }, (_, i) => (
          <div key={i} className="flex items-center gap-3 py-3">
            <div className="w-12 space-y-1">
              <div className="h-3 w-8 animate-pulse rounded bg-muted" />
              <div className="h-5 w-6 animate-pulse rounded bg-muted" />
            </div>
            <div className="h-14 flex-1 animate-pulse rounded-lg bg-muted" />
          </div>
        ))}
      </div>
    </motion.div>
  );
}
